module.exports = __webpack_public_path__ + "img/1sb_mini_logo_white.fe001f4.svg";